import { Reveal } from "@/components/motion";
import CTAButton from "@/components/CTAButton";
import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section className="relative border-t border-border py-24 sm:py-32" data-testid="final-cta-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="relative overflow-hidden rounded-[32px] border border-border bg-card px-6 py-16 text-center sm:px-12 sm:py-24">
          <div
            className="pointer-events-none absolute left-1/2 top-0 h-[400px] w-[700px] -translate-x-1/2 rounded-full opacity-[0.14] blur-[110px]"
            style={{ background: "var(--brand-gradient)" }}
            aria-hidden="true"
          />
          <div className="grid-lines pointer-events-none absolute inset-0 opacity-30 [mask-image:radial-gradient(ellipse_at_center,black,transparent_70%)]" />
          <div className="relative">
            <h2 className="mx-auto max-w-2xl font-display text-3xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
              Run your business from one connected workspace.
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-base text-muted-foreground sm:text-lg">
              Start free today and be first in line as every Workspace module goes live.
            </p>
            <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <CTAButton to="/signup" variant="gradient" size="lg" data-testid="final-start-free-btn">
                Start Free <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </CTAButton>
              <CTAButton to="/contact" variant="outline" size="lg" data-testid="final-contact-btn">
                Talk to us
              </CTAButton>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
